import { createFormStageContext } from 'BreetHelpers';

import { type CURRENCYCONVERTERSTAGESTYPE } from '../DialogCurrencyConverter.helpers';

export const { ContextComponent: CurrencyConverterFormStageContext, useFormStageContext: useCurrencyConverterFormStageContext } =
	createFormStageContext<CURRENCYCONVERTERSTAGESTYPE>();
